module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "root"
    }
  }, [(_vm.store.page.showTopNav) ? _c('div', {
    staticClass: "top-nav"
  }, [_c('button', {
    staticClass: "desktop-back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left2"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-title"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.store.page.title))])]), _vm._v(" "), (_vm.store && _vm.currentUser) ? _c('img', {
    staticClass: "global-sul-logo",
    attrs: {
      "src": require("img/sul-logo.svg")
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.currentUser) ? _c('div', {
    staticClass: "bottom-nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "bottom-nav-button icon-home"
  })]), _vm._v(" "), (_vm.store.selectedEvent) ? _c('router-link', {
    attrs: {
      "to": "/invite-sponsor"
    }
  }, [_c('span', {
    staticClass: "bottom-nav-button icon-mail4"
  })]) : _vm._e(), _vm._v(" "), (_vm.store.selectedEvent) ? _c('router-link', {
    attrs: {
      "to": "/add-sponsor"
    }
  }, [_c('span', {
    staticClass: "bottom-nav-button icon-user-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.store.selectedEvent) ? _c('router-link', {
    attrs: {
      "to": "/sponsors"
    }
  }, [_c('span', {
    staticClass: "bottom-nav-button icon-users"
  })]) : _vm._e(), _vm._v(" "), (_vm.store.selectedOrganization && _vm.store.selectedEvent) ? _c('router-link', {
    attrs: {
      "to": "/statistics/user"
    }
  }, [_c('span', {
    staticClass: "bottom-nav-button icon-stats-bars"
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/myprofile"
    }
  }, [_c('span', {
    staticClass: "bottom-nav-button icon-cog"
  })])], 1) : _vm._e(), _vm._v(" "), _c('kk-popup')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67916f9a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/KkRoot.vue
// module id = 121
// module chunks = 0